export default class DateType {
  public periode: number;
  public typePeriode: string;
  public dateFin: Date = new Date();
  public dateDebut: Date = new Date();
  public dates: Date[] = [new Date()];
  public trancheHoraire: boolean = false;
  public datesMultiples: boolean = false;
  public heureDebut: string = "12:00";
  public heureFin: string = "12:00";

  constructor() {
    this.periode = 0;
    this.typePeriode = "J";
  }

  public setDateDebut(dd: Date) {
    this.dateDebut = dd;
  }

  // @ts-ignore
  public setDateFin(df: Date) {
    this.dateFin = df;
  }

  public setDates(dates: Date[]) {
    this.dates = dates;
  }
}
